import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import * as colors from '~/constants/colors'

const heroLg = `${process.env.GATSBY_IMAGES}patients/hero-lg.png`;
const heroMd = `${process.env.GATSBY_IMAGES}patients/hero-md.png`;
const heroSm = `${process.env.GATSBY_IMAGES}patients/hero-sm.jpg`;

import { TYPOGRAPHY } from '~/constants/typography'

export default makeStyles((theme: Theme) =>
    createStyles({
        smHero: {
            backgroundImage: `url(${heroSm})`,
            height: 432,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: `center`,
            backgroundSize: 'cover',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        hero: {
            background: `url(${heroLg}), ${colors.GREY_COLOR.Grey6}`,
            boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.16)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: `100% ${theme.spacing(-4)}px`,
            backgroundSize: 'contain',
            width: '100%',
            height: 622,
            paddingBottom: theme.spacing(4),
            [theme.breakpoints.down('md')]: {
                background: `url(${heroMd}), ${colors.GREY_COLOR.Grey6}`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: `100% -134px`,
                backgroundSize: 'contain',
            },
            [theme.breakpoints.down('sm')]: {
                background: colors.GREY_COLOR.Grey6,
                height: 'auto',
            },
            [theme.breakpoints.down('xs')]: {
                height: 'auto',
            },
        },
        heroInner: {
            paddingTop: `96px !important`,
            [theme.breakpoints.down('sm')]: {
                '&&&': {
                    padding: theme.spacing(5),
                    paddingTop: `${theme.spacing(5)}px !important`,
                    paddingBottom: theme.spacing(8),
                },
            },
            [theme.breakpoints.down('xs')]: {
                '&&&': {
                    padding: theme.spacing(2),
                    paddingTop: `${theme.spacing(4)}px !important`,
                    paddingBottom: theme.spacing(4),
                },
            },
        },
        heroTitle: {
            color: theme.palette.primary.dark,
            marginBottom: theme.spacing(2),
            [theme.breakpoints.down('sm')]: {
                fontSize: 50,
            },
            [theme.breakpoints.down('xs')]: {
                ...TYPOGRAPHY.subtitle1,
            },
        },
        heroButton: {
            paddingLeft: 0,
            marginTop: theme.spacing(3),
        },
        heroText: {
            width: '40%',
            color: colors.GREY_COLOR.Grey1,
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },
        heroContainer: {
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
        partnering: {
            [theme.breakpoints.down('xs')]: {
                marginTop: theme.spacing(8),
            },
        },
        sectionTitle: {
            color: colors.GREY_COLOR.Grey2,
            marginBottom: theme.spacing(3),
        },
        videoContainer: {
            [theme.breakpoints.down('sm')]: {
                paddingLeft: 0,
                paddingRight: 0,
            },
        },
        beforeVideo: {
            paddingTop: 96,
            paddingBottom: theme.spacing(8),
            [theme.breakpoints.down('xs')]: {
                paddingTop: theme.spacing(8),
            },
        },
        h3Title: {
            color: theme.palette.primary.dark,
            marginBottom: theme.spacing(2),
            [theme.breakpoints.down('md')]: {
                ...TYPOGRAPHY.h4,
            },
        },
        text: {
            color: colors.GREY_COLOR.Grey1,
        },
        centered: {
            display: 'block',
            textAlign: 'center',
        },
        work: {
            '&&': {
                [theme.breakpoints.down('md')]: {
                    padding: theme.spacing(1.5),
                },
                [theme.breakpoints.down('sm')]: {
                    padding: theme.spacing(1.5),
                    paddingLeft: 0,
                    paddingRight: 0,
                },
                [theme.breakpoints.down('xs')]: {
                    padding: theme.spacing(1, 0),
                },
            },
        },
        works: {
            marginTop: theme.spacing(5),
            [theme.breakpoints.down('sm')]: {
                maxWidth: 336,
                margin: '0 auto',
            },
            [theme.breakpoints.down('xs')]: {
                maxWidth: 'fit-content',
            },
        },
        workImage: {
            backgroundRepeat: 'no-repeat',
            height: 128,
            width: 128,
            backgroundSize: 'cover',
            marginBottom: theme.spacing(3),
        },
        workDescription: {
            textAlign: 'center',
            color: colors.GREY_COLOR.Grey1,
        },
        worksContainer: {
            paddingTop: theme.spacing(5),
        },
        workCard: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        workIndex: {
            color: '#88bcef',
            position: 'absolute',
            left: theme.spacing(4),
            top: theme.spacing(2),
        },
        slider: {
            marginTop: theme.spacing(8),
            marginBottom: 128,
        },
        affordable: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
            },
        },
        affordableContainer: {
            marginBottom: 0,
            [theme.breakpoints.down('xs')]: {
                paddingTop: theme.spacing(5),
            },
        },
        affordableImage: {
            maxWidth: 264,
            width: '100%',
            marginRight: 100,
            [theme.breakpoints.down('sm')]: {
                marginRight: 80,
            },
            [theme.breakpoints.down('xs')]: {
                marginRight: 0,
                marginBottom: theme.spacing(8),
            },
        },
        affordableTitle: {
            marginBottom: theme.spacing(2),
        },
        affordableBlock: {
            width: '35%',
            [theme.breakpoints.down('sm')]: {
                width: '50%',
            },
            [theme.breakpoints.down('xs')]: {
                width: '100%',
            },
        },
    })
)
